import { render, staticRenderFns } from "./ver_plan_q10.vue?vue&type=template&id=150f7ffc"
import script from "./ver_plan_q10.vue?vue&type=script&lang=js"
export * from "./ver_plan_q10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports